"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setReadyState = void 0;
const dataLayerKey = 'dataLayer';
const reactIsReadyKey = 'reactIsReady';
const aemScriptIsReadyKey = 'aemScriptIsReady';
const clientIsReadyKey = 'clientIsReady';
const setState = () => {
    if (window[aemScriptIsReadyKey] && !window[clientIsReadyKey]) {
        if (typeof window !== 'undefined' && 'performance' in window) {
            performance === null || performance === void 0 ? void 0 : performance.mark('as-react-is-ready-client');
        }
        window[clientIsReadyKey] = true;
        window[dataLayerKey] = window[dataLayerKey] || [];
        window[dataLayerKey].push({
            event: clientIsReadyKey,
        });
        const event = document.createEvent('Event');
        event.initEvent(clientIsReadyKey, true, true);
        document.dispatchEvent(event);
    }
};
const setReadyState = () => {
    if (typeof window !== 'undefined' && 'performance' in window) {
        performance === null || performance === void 0 ? void 0 : performance.mark('as-react-is-ready-react');
    }
    window[reactIsReadyKey] = true;
    if (!window[aemScriptIsReadyKey]) {
        document.body.addEventListener(aemScriptIsReadyKey, setState);
    }
    else {
        setState();
    }
};
exports.setReadyState = setReadyState;
//# sourceMappingURL=setReadyState.js.map